import * as React from "react";
function SvgComment(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <path
        fill="#fff"
        d="M16 24.32l2.38-3.57h6.56a.68.68 0 00.68-.69v-11a.67.67 0 00-.68-.68H7.06a.67.67 0 00-.68.68v11a.68.68 0 00.68.69h6.56zm0 2.48l-3.12-4.68H7.06A2.06 2.06 0 015 20.06v-11A2.06 2.06 0 017.06 7h17.88A2.06 2.06 0 0127 9.06v11a2.06 2.06 0 01-2.06 2.06h-5.82z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgComment);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
